import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import './marketingCarousel.css';
function EducationMaketing() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const getFormations = async () => {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "activities/Formations"
      );
      setData(response.data.formations);
    };
    getFormations();
  }, []);

  return (
    <div className="prochainFormationsMarketing">
    {data &&
      data.map(
        (e, i) =>
        (e.date && e.date!==" " ) && (
            <Link  to={`/education/formation/${e._id}`}
              className="prochainFormationMarketing"
              key={e._id}
            >
              <img
                className="imageProchaineFormationMarketing"
                src={e.images && e.images.url}
                alt=""
              />
              <div className="informationsProchaineFormationMarketing">
                <div className="titreProchaineFormationMarketing">
                  {e.name && e.name}
                </div>
                <div className="descriptionProchaineFormationMarketing">
                  {(e.date && e.date!==" " )&& e.date}
                </div>
              </div>
            </Link>
          )
      )}
  </div>
  );
}

export default EducationMaketing;
